import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track2CBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track2CBlue" transform="translate(1045.000000, 610.000000)" className="track">
		<g id="line" transform="translate(0.500000, 8.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path d="M57.0847168,21 L57.1039445,20.9384959 C59.5051692,13.2576506 65.3482563,7.13428941 72.9082594,4.37609863 C80.7021678,1.5325699 89.1984953,1.24162281 97.1686649,3.54532859 L119.5,10 L119.5,10 L172,37"/>
			<path    d="M83.8197567,55.1738281 L65.1276069,40.8248607 C61.2576134,37.8540729 58.6069754,33.5711598 57.6746277,28.7823022 L57.5422363,28.1022949 L57.5422363,28.1022949"/>

			<path
				d="M185,40.5 L304.167327,87.2502591 C311.364826,90.0738933 318.210581,93.7227099 324.567403,98.1235866 L328,100.5 C336.003111,106.040615 340.305398,115.537696 339.19291,125.207782 L334.5,166 L334.5,166"/>

			<line x1="83.8197567" y1="55.1738281" x2="109" y2="76"/>

			<TrackArrow
				transform="translate(58.165396, 31.040369) rotate(-287.000000) translate(-58.165396, -31.040369)"
									points="62.1653958 39.0403693 54.1653958 31.0403693 62.1653958 23.0403693"/>

			<TrackArrow transform="translate(170.500000, 36.000000) rotate(-148.000000) translate(-170.500000, -36.000000)"
									points="174.5 44 166.5 36 174.5 28"/>

			<line x1="86.5" y1="81" x2="28.5" y2="90"/>
			<line x1="110.5" y1="77" x2="98.1967725" y2="79.0060831"/>

			<TrackArrow
				transform="translate(84.258757, 81.217390) rotate(-189.000000) translate(-84.258757, -81.217390) "
				points="88.2587568 89.2173899 80.2587568 81.2173899 88.2587568 73.2173899"/>

			<line x1="0.417442747" y1="110.576492" x2="25.3750146" y2="89.4379348"/>
			<path
				d="M334.5,166.005074 L293.000843,213.754644 C278.509359,230.428769 280.27874,255.693485 296.952864,270.184969 C298.783232,271.775742 300.754471,273.196769 302.842229,274.430494 L334.5,293.138121 L334.5,293.138121 L394.682412,305"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track2CBlue')}
			coords="106.941960, 0.000000"
			text="2C"
			textCoordsX="10.6831055"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track2CBlue')}
			coords="291.941960, 182.000000"
			text="2C"
			textCoordsX="10.6831055"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track2CBlue.propTypes = trackPropTypes;

export default Track2CBlue;
